<app-modal-component [open]="openModal" label="Edit message">
  <div class="cf-shell cf-shell--wide">
    <app-form-wrapper title="Edit message" (iconClick)="onClose.emit()" icon="close">
      <form class="cf" [formGroup]="messagesForm" (ngSubmit)="onSubmit()" novalidate>
        <p class="cf__lead">Changes apply to sends that have not gone out yet. Schedules are edited from the message card.</p>

        <div class="cf__grid">
          <!-- sender id -->
          <input-field
            label="Sender ID"
            [errorMessage]="submitted && senderId?.invalid ? 'Choose a sender ID.' : ''"
          >
<bk-select
            formControlName="senderId"
            [options]="senderIDs"
            valueKey="senderId"
            variant="sender"
            noun="sender ID"
            placeholder="Choose a sender ID"
            emptyText="No sender IDs available"
          />
          </input-field>

          <!-- message template -->
          <input-field label="Template" hint="Optional. Fills in the message below.">
<bk-select
              formControlName="template"
              [options]="templates"
              valueKey="id"
              labelKey="name"
              detailKey="content"
              variant="template"
              noun="template"
              placeholder="Start from a template"
              emptyText="No templates yet"
              (valueChange)="handleSelectTemplate($event)"
            />
          </input-field>

          <!-- message subject -->
          <input-field
            class="cf__wide"
            label="Subject"
            hint="For your team only. Recipients do not see it."
            [errorMessage]="submitted && subject?.invalid ? 'Enter a subject.' : ''"
          >
            <input type="text" class="input-style" placeholder="For example, October offer reminder" formControlName="subject" />
          </input-field>

          <!-- Message Body -->
          <input-field
            class="cf__wide"
            label="Message"
            [hint]="partsLabel"
            [errorMessage]="submitted && body?.invalid ? 'Write the message.' : ''"
          >
            <div class="cf__body-row">
              <textarea
                #messageTextarea
                name="body"
                id="body"
                rows="5"
                class="input-style"
                placeholder="What recipients will read"
                formControlName="body"
              ></textarea>
              <message-attribute-menu (select)="appendAttribute(messageTextarea, $event)"></message-attribute-menu>
            </div>

            <!-- added contact-attribute chips -->
            <message-attribute-chips
              [message]="body?.value || ''"
              (remove)="removeAttribute($event)"
            ></message-attribute-chips>
          </input-field>
        </div>

        <!-- buttons -->
        <div class="cf__foot">
          <customizable-button title="Cancel" [outline]="true" (click)="onClose.emit()" type="button" />
          <customizable-button title="Save message" [loading]="campaignsService.isLoading" type="submit" />
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
